// src/models/Task.js

import apiClient from '../axios'


class Task {
  constructor(data) {
    this.title = data.title
    this.line = data.line
    this.completed = data.completed
    this.completedAt = null
    this.lineNumber = data.lineNumber
    this.file = data.file

    if (data.completedAt) {
      this.completedAt = new Date(data.completedAt)
    }
  }

  static apiBaseUrl = process.env.VUE_APP_API_BASE_URI

  static async list() {
    try {
      const response = await apiClient.get('/tasks')
      return response.data.tasks.map(taskData => new Task(taskData))
    } catch (error) {
      console.error('Error fetching tasks:', error)
      throw error
    }
  }

  async create() {
    try {
      const response = await apiClient.post('/tasks', this.toObject())
      const newData = response.data.task
      
      this.title = newData.title
      this.line = newData.line
      this.completed = newData.completed
      this.completedAt = null
      if(newData.completedAt) {
        this.completedAt = new Date(newData.completedAt)
      }
      return response.data
    } catch (error) {
      console.error('Error creating task:', error)
      throw error
    }
  }


  toggleCompleted() {
    this.completed = !this.completed
    if (this.completed) {
      this.completedAt = new Date()
    } else {
      this.completedAt = null
    }
    this.update();
  }

  toObject() {
    const data = {
      title: this.title,
      line: this.line,
      completed: this.completed,
      completedAt: null,
      lineNumber: this.lineNumber,
      file: this.file
    }

    if (this.completedAt) {
      data.completedAt = this.completedAt.toISOString()
    }
    return data
  }

  async update() {
    try {
      const data = this.toObject()
      const response = await apiClient.post(`/tasks/edit`, data)
      const newData = response.data.task
      
      this.title = newData.title
      this.line = newData.line
      this.completed = newData.completed
      this.completedAt = null
      if(newData.completedAt) {
        this.completedAt = new Date(newData.completedAt)
      }
      
      // return response.data
    } catch (error) {
      console.error('Error updating task:', error)
      throw error
    }
  }

}

export default Task